import React, { useState } from "react";
import PopupWrapper from "../../../../components/PopupWrapper";
import { OTPInputComponent } from "../../../Login/LoginComp";
import { LoadingButton } from "../../../../Utils/CustomComponent";

const DeleteAccountModaal = ({
  show,
  setShow,
  AccountSelect,
  selectedPaymentAccount,
}) => {
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [promptFail, setPromptFail] = useState(null);
  const [otpEntered, setOtpEntered] = useState("");
  const [isOtpStage, setIsOtpStage] = useState(false);
  const [afterOtpLoading, setAfterOtpLoading] = useState(false);
  const [disableFWS, setDisableFWS] = useState(false);
  const [otpReceived, setOtpReceived] = useState("");

  function handleClose() {
    setShow(false);
    setShowOtpInput(false);
    setPromptFail(null);
    setOtpEntered("");
    setIsOtpStage(false);
    setAfterOtpLoading(false);
    setDisableFWS(false);
    setOtpReceived("");
  }

  function handleOtp() {}

  function onSubmit() {}

  return (
    <PopupWrapper
      title="Delete Bank Account"
      extraClass="width-800"
      titleClassName="px-5"
      Component={
        <div>
          <form>
            {AccountSelect}

            <div className="form-outline mb-1">
              {showOtpInput && (
                <>
                  <OTPInputComponent
                    setOtpEntered={setOtpEntered}
                    setOtpReceived={setOtpReceived}
                    onClick={() => handleOtp()}
                    requestFromCHPayment={true}
                  />
                </>
              )}
            </div>

            <div className="text-center pt-1 mt-5 mb-5 pb-1">
              {showOtpInput ? (
                <LoadingButton
                  className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
                  type="button"
                  onClick={onSubmit}
                  title={"Verify OTP and Continue"}
                  disabled={afterOtpLoading}
                  loading={afterOtpLoading}
                />
              ) : (
                <LoadingButton
                  className="btn btn-primary w-100 btn-block fa-lg gradient-custom-2 mb-3 text-white"
                  type="button"
                  onClick={onSubmit}
                  disabled={disableFWS}
                  loading={disableFWS}
                  title={"Continue"}
                />
              )}

              {promptFail && (
                <div className="alert alert-error" role="alert">
                  {promptFail}
                </div>
              )}
              <br />
            </div>
          </form>
        </div>
      }
      toShow={show}
      closeEventHandler={handleClose}
      backdrop="static"
    />
  );
};

export default DeleteAccountModaal;
